import { Tabs } from '@/components/tabs/Tabs';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { PremiumStores } from '@/services/premiumStores/premiumStores.types';
import { parseAsInteger, parseAsString, useQueryState } from 'nuqs';
import { useMemo } from 'react';
import { ApprovedStoreTable } from './approvedTable/table';
import { RejectedStoreTable } from './rejectedTable/table';
import { PendingStoreTable } from './table';

const PremiumStore = ({
  data,
  isLoading,
  pagination,
}: {
  data: PremiumStores[];
  isLoading: boolean;
  pagination: Pagination;
}) => {
  const { t } = useDynamicLocale();

  const tabItems = useMemo(
    () => [
      {
        label: t('storeManagement.premiumStores.table.tabs.approved'),
        value: 'A',
        content: <ApprovedStoreTable data={data} isLoading={isLoading} pagination={pagination} />,
      },
      {
        label: t('storeManagement.premiumStores.table.tabs.pending'),
        value: 'P',
        content: <PendingStoreTable data={data} isLoading={isLoading} pagination={pagination} />,
      },
      {
        label: t('storeManagement.premiumStores.table.tabs.rejected'),

        value: 'R',
        content: <RejectedStoreTable data={data} isLoading={isLoading} pagination={pagination} />,
      },
    ],
    [t, data, isLoading, pagination],
  );

  const [activeTab, setActiveTab] = useQueryState('activeTab', parseAsString.withDefault('A'));
  const [, setPage] = useQueryState('page', parseAsInteger.withDefault(0));
  const [, setCreatedDate] = useQueryState('createdDate', parseAsString);
  const [, setSearchQuery] = useQueryState('q', parseAsString);

  const onTabChange = (tab: string): void => {
    void Promise.all([setActiveTab(tab), setPage(0), setCreatedDate(null), setSearchQuery(null)]);
  };

  return (
    <Tabs
      className="rounded-lg shadow bg-muted"
      listClassName="bg-muted"
      triggerClassName="bg-muted rounded-t-[8px] px-6 py-3"
      defaultActive={activeTab}
      items={tabItems}
      onChange={onTabChange}
    />
  );
};

export default PremiumStore;
